import React, { useContext } from 'react';
import { getContext } from 'common';
import { AppToolbarContext } from './';

import Styled from './styles';

export interface AppToolbarButtonRowProps extends React.ComponentPropsWithRef<'div'> {
  /** The content of the row. Consider using <IconButton/> and <ToggleButton> components. */
  children: React.ReactNode;
}

/**
 * <AppToolbarButtonRow /> can be used to render a row of icon or toggle buttons on the AppToolbar.
 * All other props will be provided to the wrapper element.
 * To get the ref of the outermost element use `ref` prop. [Read React useRef hook documentation](https://reactjs.org/docs/hooks-reference.
 */
const AppToolbarButtonRow = React.forwardRef<HTMLElement, AppToolbarButtonRowProps>((props: AppToolbarButtonRowProps, ref) => getContext(({ RTL }) => {
  const {
    children,
    ...otherProps
  } = props;
  const appToolbarContext: any = useContext(AppToolbarContext);
  return (
    <Styled.AppToolbarButtonRow
      ref={ref}
      $rtl={RTL}
      $deviceType={appToolbarContext.deviceType}
      {...otherProps}
    >
      {children}
    </Styled.AppToolbarButtonRow>
  );
}));

AppToolbarButtonRow.displayName = 'AppToolbarButtonRow';

export default AppToolbarButtonRow;
